import { createAction } from '@reduxjs/toolkit';
import { AnyUser } from '../../../general/model';
import { Settings } from './model';

export const initStarted = createAction('chub/app/initStarted');

export const initListeners = createAction('creativeHub/app/initListeners');

export const initialized = createAction('creativeHub/app/initialized');

export const nodeIDChanged = createAction<{ nodeID: number }, 'creativeHub/app/NODE_ID_CHANGED'>(
  'creativeHub/app/NODE_ID_CHANGED',
);

export const usersPreloaded = createAction<{ users: AnyUser[] }, 'creativeHub/app/usersPreloaded'>(
  'creativeHub/app/usersPreloaded',
);

export const nodeIdErased = createAction<void, 'creativeHub/app/NODE_ID_ERASED'>(
  'creativeHub/app/NODE_ID_ERASED',
);
export const shareIdChanged = createAction<{ shareId: string }, 'creativeHub/app/SHARE_ID_CHANGED'>(
  'creativeHub/app/SHARE_ID_CHANGED',
);
export const loadRootNodeStarted = createAction<void, 'creativeHub/app/LOAD_ROOT_NODE_STARTED'>(
  'creativeHub/app/LOAD_ROOT_NODE_STARTED',
);
export const loadRootNodeSuccess = createAction<
  { result: any; nodeId: number },
  'creativeHub/app/LOAD_ROOT_NODE_SUCCESS'
>('creativeHub/app/LOAD_ROOT_NODE_SUCCESS');
export const loadRootNodeError = createAction<
  { error: any },
  'creativeHub/app/LOAD_ROOT_NODE_ERROR'
>('creativeHub/app/LOAD_ROOT_NODE_ERROR');
export const setNodeFlag = createAction<
  { nodeID: number; flag: any },
  'creativeHub/app/SET_NODE_FLAG'
>('creativeHub/app/SET_NODE_FLAG');

export const settingsLoaded = createAction<{ settings: Settings }>(
  'creativeHub/app/SETTINGS_LOADED',
);

export const slowNetworkChanged = createAction<
  { slow: boolean },
  'creativeHub/app/SLOW_NETWORK_CHANGED'
>('creativeHub/app/SLOW_NETWORK_CHANGED');
